import React, { useState, useEffect } from "react";
import { Pagination, PaginationLink, PaginationItem } from "reactstrap";
import Icon from "../icon/Icon";
import FormDropdown from "../../components/FormElements/FormDropdown";

const PaginationComponent = ({
  itemPerPage,
  setItemPerPage,
  totalItems,
  paginate,
  currentPage,
  setCurrentPage,
  fetchData,
  dropdown = true,
}) => {
  const pageNumbers = [];
  const [from, setIsFrom] = useState(1);
  const [to, setIsTo] = useState(currentPage * itemPerPage);
  const [tempSize, setTempSize] = useState(itemPerPage);
  const options = [
    {
      label: 20,
      value: 20,
    },
    {
      label: 50,
      value: 50,
    },
    {
      label: 100,
      value: 100,
    },
    {
      label: 200,
      value: 200,
    },
    {
      label: 500,
      value: 500,
    },
  ];

  useEffect(() => {
    setIsFrom(1);
    setIsTo(currentPage * itemPerPage);
  }, [currentPage - 1 === 0 && from > 1]);

  for (let i = 1; i <= Math.ceil(totalItems / itemPerPage); i++) {
    pageNumbers.push(i);
  }

  const nextPage = () => {
    paginate(currentPage + 1);
    setIsFrom(from + itemPerPage);
    let tempTo = to + itemPerPage;
    if (tempTo > totalItems) {
      setIsTo(totalItems);
    } else {
      setIsTo(to + itemPerPage);
    }
  };

  const prevPage = () => {
    paginate(currentPage - 1);
    setIsFrom(from - itemPerPage);
    if (to === totalItems) {
      let tempTo = to - from + 1;
      setIsTo(to - tempTo);
    } else {
      setIsTo(to - itemPerPage);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      setItemPerPage(Number(e.target.value));
      setIsFrom(1);
      setIsTo(Number(e.target.value));
      setCurrentPage(1);
      fetchData(0, e.target.value);
    }
  };

  const handleChange = (event) => {
    console.log(event);
    setTempSize(event.target.value);
  };

  return (
    <>
      <Pagination aria-label="Page navigation example">
        {/* <input type="number" 
      onKeyPress={(e) => {  
        handleKeyPress(e);
      }} 
      onChange={handleChange}
      className="size" style={{marginRight: '7px', width: '60px'}} value={tempSize}/>  */}
        {dropdown && (
          <div style={{ position: "absolute", marginTop: "-23px" }}>
            <FormDropdown
              options={options}
              onChangeHandler={(e) => {
                setTempSize(e.target.value);
                setItemPerPage(Number(e.target.value));
                setIsFrom(1);
                setIsTo(Number(e.target.value));
                setCurrentPage(1);
                fetchData(0, e.target.value);
              }}
              defaultValue={itemPerPage}
              name="paginationSize"
              showDefaultOption={false}
            />
          </div>
        )}
        <span style={{ marginRight: "1.5%", marginLeft: dropdown ? "70px" : "", paddingTop: "7px" }}>
          {from} - {to} of {totalItems}
        </span>
        <PaginationItem disabled={currentPage - 1 === 0 ? true : false}>
          <PaginationLink
            className="page-link-prev"
            onClick={(ev) => {
              ev.preventDefault();
              prevPage();
            }}
            href="#prev"
          >
            <Icon name="chevrons-left" />
            <span>Prev</span>
          </PaginationLink>
        </PaginationItem>
        {/* {pageNumbers.map((item) => {
        return (
          <PaginationItem className={currentPage === item ? "active" : ""} key={item}>
            <PaginationLink
              tag="a"
              href="#pageitem"
              onClick={(ev) => {
                ev.preventDefault();
                paginate(item);
              }}
            >
              {item}
            </PaginationLink>
          </PaginationItem>
        );
      })} */}

        <PaginationItem disabled={pageNumbers[pageNumbers.length - 1] === currentPage}>
          <PaginationLink
            className="page-link-next"
            onClick={(ev) => {
              ev.preventDefault();
              nextPage();
            }}
            href="#next"
          >
            <span>Next</span>
            <Icon name="chevrons-right" />
          </PaginationLink>
        </PaginationItem>
      </Pagination>
    </>
  );
};
export default PaginationComponent;
